import { useAnalytics } from "app/hooks/shared/analytics/useAnalytics";
import { useCartContext } from "app/providers/CartProvider";
import {
  CheckoutTabIds,
  useCheckoutTabsContext,
} from "pages/checkout/providers/CheckoutTabsProvider";
import { useNavigate } from "react-router";
import Button, { ButtonArrowTypes, ButtonTypes } from "shared/ui/button";
import Icon, { IconTypes } from "shared/ui/icon";
import { isDevelopmentEnvironment } from "shared/utils/checkEnvironment";

const CheckoutFooterButtons = () => {
  const { updateCurrentTab } = useCheckoutTabsContext();
  const { onBeginCheckout, onBeginStandardProductCheckout } = useAnalytics();

  const cartContext = useCartContext();
  const cart = cartContext.cart;
  const containsZakelijkProducts = cartContext.containsZakelijkProducts;

  const onPlanAppointmentClick = () => {
    if (cart.products.length)
      onBeginCheckout(cart, cartContext.getVoucherDisplay());
    if (cart.standardProducts.length)
      onBeginStandardProductCheckout(cart, cartContext.getVoucherDisplay());

    updateCurrentTab(CheckoutTabIds.PERSONAL_INFO);
  };

  // Get the navigate function from useNavigate
  const navigate = useNavigate();

  // Define the function to handle the continue shopping click
  // Staging, production => /producten
  // Development => /
  const onContinueShopping = () => {
    if (!isDevelopmentEnvironment()) {
      let url = "/producten";
      if (containsZakelijkProducts) {
        url = "/zakelijk/producten";
      }
      window.location.href = url;
    }
  };

  const buttonText = (() => {
    // doors
    if (cart.products.length > 0) {
      // assembly
      if (cart.isSelfAssembly) {
        return "Bestellen";
      }
      // normal door
      return "Plan je gratis afspraak";
    }

    // std products + default
    return "Verder";
  })();

  return (
    <div className="gg-grid gg-w-full gg-grid-cols-1 gg-gap-y-6 gg-text-base gg-font-bold sm:gg-grid-cols-2 sm:gg-gap-x-5 md:gg-gap-y-0 lg:gg-col-span-2 lg:gg-gap-8 lg:gg-justify-self-end xl:gg-w-auto">
      <Button
        type={ButtonTypes.WHITE}
        arrow={ButtonArrowTypes.LEFT}
        onClick={() => onContinueShopping()}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-px-5 gg-py-3 lg:gg-max-w-full"
      >
        Verder winkelen
      </Button>

      <Button
        onClick={() => onPlanAppointmentClick()}
        type={ButtonTypes.YELLOW}
        className="gg-flex gg-w-full gg-items-center gg-justify-center gg-justify-self-end gg-whitespace-nowrap gg-px-5 gg-py-3 lg:gg-max-w-full"
        data-testid="proceed-to-personal-info-button"
      >
        {buttonText}
        <Icon
          name={IconTypes.ARROW_RIGHT}
          className="gg-ml-4 sm:gg-ml-2 lg:gg-ml-3"
        />
      </Button>
    </div>
  );
};
export default CheckoutFooterButtons;
